export default __webpack_public_path__ + "static/media/waggle.488a2715.svg";